// 表示件数 option
const PerPage = [
  {
    value: 20,
    label: '20件表示',
  },
  {
    value: 30,
    label: '30件表示',
  },
  {
    value: 50,
    label: '50件表示',
  },
  {
    value: 100,
    label: '100件表示',
  },
  {
    value: 200,
    label: '200件表示',
  },
]

export default PerPage
